import http from "./axios";

export default {
  async getSeasons() {
    try {
      return await http.get(`/api/seasons`);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
};
